import { action, computed, makeObservable, observable } from 'mobx';
import { v4 } from 'uuid';

import type { TFactTrajectoryPoint } from '../model';

export type TPointData = {
  md?: number | null;
  inc?: number | null;
  azMag?: number | null;
  azTrue?: number | null;
  tvd?: number | null;
  tvdss?: number | null;
  ns?: number | null;
  we?: number | null;
  northing?: number | null;
  easting?: number | null;
  closure?: number | null;
  vsec?: number | null;
  ahd?: number | null;
  dls?: number | null;
  tfo?: number | null;
};

export class FactTrajectoryPointEntity {
  readonly entityId = v4();
  private _initialData: TPointData = {};

  @observable private _data: TPointData = {};

  constructor(initialData?: Partial<TFactTrajectoryPoint>) {
    this._initialData = initialData ?? {};
    this._data = initialData ?? {};

    makeObservable(this);
  }

  get initialData(): TPointData {
    return this._initialData;
  }

  @computed
  get data(): TPointData {
    return this._data;
  }

  @action.bound
  updateData(data: Partial<TPointData>): void {
    this._data = { ...this.data, ...data };
  }
}
